<!-- =========================================================================================
    File Name: VerticalNavMenuItem.vue
    Description: Vertical NavMenu item component. Extends vuesax framework's 'vs-sidebar-item' component
    Component Name: VerticalNavMenuItem
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div
    v-if="canSee"
    class="vs-sidebar--item"
    :class="[
      {'vs-sidebar-item-active'            : activeLink},
      {'disabled-item pointer-events-none' : isDisabled}
    ]" >

      <router-link
        tabindex="-1"
        v-if="to"
        exact
        :class="[{'router-link-active': activeLink}]"
        :to="to"
        :target="target" >
          <vs-icon v-if="!featherIcon" :icon-pack="iconPack" :icon="icon" />
          <feather-icon v-else :class="{'w-3 h-3': iconSmall}" :icon="icon" />
          <slot />
      </router-link>

      <a v-else :target="target" :href="href" tabindex="-1">
        <vs-icon v-if="!featherIcon" :icon-pack="iconPack" :icon="icon" />
        <feather-icon v-else :class="{'w-3 h-3': iconSmall}" :icon="icon" />
        <slot />
      </a>
  </div>
</template>

<script>
export default {
  name: 'v-nav-menu-item',
  props: {
    icon        : { type: String,                 default: ""               },
    iconSmall   : { type: Boolean,                default: false            },
    iconPack    : { type: String,                 default: 'material-icons' },
    href        : { type: [String, null],         default: '#'              },
    to          : { type: [String, Object, null], default: null             },
    slug        : { type: String,                 default: null             },
    index       : { type: [String, Number],       default: null             },
    featherIcon : { type: Boolean,                default: true             },
    target      : { type: String,                 default: '_self'          },
    isDisabled  : { type: Boolean,                default: false            },
  },
  computed: {
    activeLink() {
      return ((this.to == this.$route.path) || (this.$route.meta.parent == this.slug) && this.to) ? true : false
    },
    canSee() {
      if (this.slug === "dashboard") {
           if ((this.$store.state.AppActiveUser.perfil === 'FINANCEIRO') ||               
               (this.$store.state.AppActiveUser.perfil === 'GESTOR_EMPRESA') ||
               (this.$store.state.AppActiveUser.perfil === 'GESTOR') ) {
                  return true;   
          }
          return false;
      }

      if (this.slug === "menu-cadastro-empresas") {
          if ( (this.$store.state.AppActiveUser.perfil === 'GESTOR')  ) {
                  return true;   
          }
          return false;
      }

      if (this.slug === "menu-cadastro-favorecidos") {
          if ( (this.$store.state.AppActiveUser.perfil === 'FINANCEIRO_CONTA_PAGAR') ||
               (this.$store.state.AppActiveUser.perfil === 'FINANCEIRO_CONTA_RECEBER') ||
               (this.$store.state.AppActiveUser.perfil === 'FINANCEIRO') ||
               (this.$store.state.AppActiveUser.perfil === 'CRM') ||
               (this.$store.state.AppActiveUser.perfil === 'CRM_CONTA_RECEBER') ||
               (this.$store.state.AppActiveUser.perfil === 'GESTOR_EMPRESA') ||
               (this.$store.state.AppActiveUser.perfil === 'GESTOR') ) {
                  return true;   
          }
          return false;
      }

      if (this.slug === "menu-cadastro-categorias-produtos") {          
            if ( (this.$store.state.AppActiveUser.perfil === 'FINANCEIRO') ||          
                 (this.$store.state.AppActiveUser.perfil === 'GESTOR_EMPRESA') ||
                 (this.$store.state.AppActiveUser.perfil === 'GESTOR') ) {
                  return true;   
          }
          return false;
      }

      if (this.slug === "menu-cadastro-produtos") {          
            if ( (this.$store.state.AppActiveUser.perfil === 'FINANCEIRO') ||          
                 (this.$store.state.AppActiveUser.perfil === 'GESTOR_EMPRESA') ||
                 (this.$store.state.AppActiveUser.perfil === 'GESTOR') ) {
                  return true;   
          }
          return false;
      }

      if (this.slug === "menu-cadastro-grupos-contas") {          
            if ( (this.$store.state.AppActiveUser.perfil === 'GESTOR_EMPRESA') ||
                 (this.$store.state.AppActiveUser.perfil === 'GESTOR') ) {
                  return true;   
          }
          return false;
      }

      if (this.slug === "menu-cadastro-contas") {          
            if ( (this.$store.state.AppActiveUser.perfil === 'GESTOR_EMPRESA') ||
                 (this.$store.state.AppActiveUser.perfil === 'GESTOR') ) {
                  return true;   
          }
          return false;
      }

      if (this.slug === "menu-cadastro-instituicoes") {          
            if ( (this.$store.state.AppActiveUser.perfil === 'GESTOR_EMPRESA') ||
                 (this.$store.state.AppActiveUser.perfil === 'GESTOR') ) {
                  return true;   
          }
          return false;
      }

      if (this.slug === "menu-cadastro-usuarios") {          
            if ( (this.$store.state.AppActiveUser.perfil === 'GESTOR_EMPRESA') ||
                 (this.$store.state.AppActiveUser.perfil === 'GESTOR') ) {
                  return true;   
          }
          return false;
      }

      if (this.slug === "menu-financeiro-remessa") {          
            if ( (this.$store.state.AppActiveUser.perfil === 'FINANCEIRO') ||          
                 (this.$store.state.AppActiveUser.perfil === 'GESTOR_EMPRESA') ||
                 (this.$store.state.AppActiveUser.perfil === 'GESTOR') ) {
                  return true;   
          }
          return false;
      }

      if (this.slug === "menu-financeiro-retorno") {          
            if ( (this.$store.state.AppActiveUser.perfil === 'FINANCEIRO') ||          
                 (this.$store.state.AppActiveUser.perfil === 'GESTOR_EMPRESA') ||
                 (this.$store.state.AppActiveUser.perfil === 'GESTOR') ) {
                  return true;   
          }
          return false;
      }



      if (this.slug === "menu-financeiro-contas-a-pagar") {
          if ( (this.$store.state.AppActiveUser.perfil === 'FINANCEIRO_CONTA_PAGAR') ||
               (this.$store.state.AppActiveUser.perfil === 'FINANCEIRO') ||
               (this.$store.state.AppActiveUser.perfil === 'GESTOR_EMPRESA') ||
               (this.$store.state.AppActiveUser.perfil === 'GESTOR')
               ) {
                  return true;   
               }
          return false;
      }

      if (this.slug === "menu-financeiro-contas-a-receber") {
          if ( (this.$store.state.AppActiveUser.perfil === 'FINANCEIRO_CONTA_RECEBER') ||
               (this.$store.state.AppActiveUser.perfil === 'FINANCEIRO') ||
               (this.$store.state.AppActiveUser.perfil === 'GESTOR_EMPRESA') ||
               (this.$store.state.AppActiveUser.perfil === 'GESTOR') ||
               (this.$store.state.AppActiveUser.perfil === 'CRM_CONTA_RECEBER') ) {
                  return true;   
               }
          return false;
      }

      if (this.slug === "menu-financeiro-item-conta-futuro") {
          if ( (this.$store.state.AppActiveUser.perfil === 'FINANCEIRO_CONTA_RECEBER') ||
               (this.$store.state.AppActiveUser.perfil === 'FINANCEIRO') ||
               (this.$store.state.AppActiveUser.perfil === 'GESTOR_EMPRESA') ||
               (this.$store.state.AppActiveUser.perfil === 'GESTOR') ||               
               (this.$store.state.AppActiveUser.perfil === 'FINANCEIRO_CONTA_PAGAR') ) {
                  return true;   
               }
          return false;
      }

      if (this.slug === "menu-relatorios") {
          if ( (this.$store.state.AppActiveUser.perfil === 'FINANCEIRO') ||
               (this.$store.state.AppActiveUser.perfil === 'GESTOR_EMPRESA') ||
               (this.$store.state.AppActiveUser.perfil === 'GESTOR') ) {
                  return true;   
               }
          return false;
      }

      if (this.slug === "menu-financeiro-conta-recorrente") {
          if ( (this.$store.state.AppActiveUser.perfil === 'GESTOR_EMPRESA') ||
               (this.$store.state.AppActiveUser.perfil === 'GESTOR') ) {
                  return true;   
               }
          return false;
      }

      if (this.slug === "menu-financeiro-compras") {
          if ( (this.$store.state.AppActiveUser.perfil === 'FINANCEIRO') ||
               (this.$store.state.AppActiveUser.perfil === 'GESTOR_EMPRESA') ||
               (this.$store.state.AppActiveUser.perfil === 'GESTOR') ||
               (this.$store.state.AppActiveUser.perfil === 'COMPRAS') ) {
                  return true;   
               }
          return false;
      }

      return false;
    }
  }
}

</script>

